import { useTranslation } from 'react-i18next';

/**
 * Read-only position display with "..." button to open the picker.
 * Same layout as OrgUnitSearchField (uses org-unit-search-field styles).
 */
export default function PositionSearchField({ displayLabel = '', onOpenPicker, className = '' }) {
    const { t } = useTranslation();
    const placeholder = t('persons.personContract.selectionOfPosition');

    return (
        <div className={`org-unit-search-field ${className}`.trim()}>
            <input
                type="text"
                className="small-input org-unit-search-field__input"
                readOnly
                placeholder={placeholder}
                value={displayLabel}
                title={displayLabel}
            />
            <button
                type="button"
                className="org-unit-search-field__btn"
                onClick={() => onOpenPicker?.()}
                title={placeholder}
            >
                ...
            </button>
        </div>
    );
}
